import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UtilisateurSaveDto } from '../../dto/utilisateur-save-dto';
import { UtilisateursService } from '../../service/utilisateurs.service';
import { UtilisateurDto } from '../../dto/utilisateur-dto';

@Component({
  selector: 'app-add-user-modal',
  templateUrl: './add-user-modal.component.html',
  styleUrls: ['./add-user-modal.component.scss']
})
export class AddUserModalComponent implements OnInit {
  nomControl: FormControl;
  prenomControl: FormControl;
  emailControl: FormControl;
  adminControl: FormControl;

  formModalIsSubmitting: boolean = false;

  constructor(
    private utilisateurService: UtilisateursService,
    private toastr: ToastrService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.nomControl = new FormControl('', [Validators.required]);
    this.prenomControl = new FormControl('', [Validators.required]);
    this.emailControl = new FormControl('', [Validators.required, Validators.email]);
    this.adminControl = new FormControl(false, [Validators.required]);
  }

  onSubmit(): void {
    if (this.nomControl.valid && this.prenomControl.valid && this.emailControl.valid) {
      this.formModalIsSubmitting = true;
  
      const newUser: UtilisateurSaveDto = {
        nom: this.nomControl.value,
        prenom: this.prenomControl.value,
        email: this.emailControl.value,
        admin: this.adminControl.value
      };
  
      this.utilisateurService.createUtilisateur(newUser).subscribe({
        next: () => {
          this.toastr.success('Utilisateur ajouté avec succès');
          this.formModalIsSubmitting = false;
          this.activeModal.close('added'); 
        },
        error: () => {
          this.toastr.error("Erreur lors de l'ajout de l'utilisateur");
          this.formModalIsSubmitting = false;
          this.activeModal.dismiss();
        }
      });
    }
  }
  

  fermerModal(): void {
    this.activeModal.dismiss();
  }
}
